import { createSelector } from '@reduxjs/toolkit';
import { versionAPI } from 'store/api/version-api.slice';

export const selectLinkedStatuses = createSelector([state => state], state => {
	return versionAPI.endpoints.getLinkedAccounts.select({})(state) ?? {};
});
